import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "../../utils/axiosInstance";
import { message } from "antd";

export const useGetModulesQuery = () => {
  const token = localStorage.getItem("BETTY_ADMIN_USER_TOKEN");

  return useQuery({
    queryKey: ["useGetModulesQuery"],
    queryFn: () =>
      axiosInstance
        .get("/admins/modules", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => res.data),

    // onError: (error: any) => {
    //   message.error(error?.response?.data?.message);
    // },
    enabled: !!token,
  });
};
